var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageboxError = function SvgMessageboxError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373A36",
    fillRule: "evenodd",
    d: "M14.32.56C6.897.56.88 6.577.88 14s6.017 13.44 13.44 13.44S27.76 21.423 27.76 14 21.743.56 14.32.56m0 1.61c6.533 0 11.83 5.297 11.83 11.83s-5.297 11.83-11.83 11.83S2.49 20.532 2.49 14 7.788 2.17 14.32 2.17m5.083 6.427a.43.43 0 0 1 .008.602l-.008.008L14.61 14l4.794 4.794a.432.432 0 0 1-.602.618l-.008-.008-4.794-4.794-4.792 4.794a.432.432 0 0 1-.618-.602l4.8-4.802-4.792-4.792a.432.432 0 0 1 .602-.618l4.8 4.8 4.794-4.792a.43.43 0 0 1 .61 0"
  })));
};
export default SvgMessageboxError;